import { helper } from '@ember/component/helper';
import subjectTypes from '@linc-technologies/linced-common/enums/subject-type';

export function findSubjectTypeByLabel([label]) {
  return subjectTypes.values.find((item) => item.label === label);
}

export default helper(findSubjectTypeByLabel);
